import styled, { css } from 'styled-components';

import { pxToRem } from 'utils/scss';

export const WrapperDateRange = styled.div`
  position: relative;
`;

export const DateRangeValue = styled.div`
  display: flex;
  justify-content: space-between;
  padding: ${pxToRem('16px')} ${pxToRem('32px')};
  border-radius: ${pxToRem('32px')};
  cursor: pointer;
  min-width: ${pxToRem('160px')};
  min-height: ${pxToRem('56px')};
  align-items: center;
`;

export const WrapperPicker = styled.div`
  position: absolute;
  top: calc(${pxToRem('56px')} + ${pxToRem('8px')} + ${pxToRem('8px')});
  left: -${pxToRem('8px')};
  padding: ${pxToRem('20px')} ${pxToRem('24px')};
  border-radius: ${pxToRem('36px')};
  box-shadow: 0 ${pxToRem('6px')} ${pxToRem('12px')} -${pxToRem('4px')} ${props => props.theme.colors.black.five};
  border: solid ${pxToRem('2px')} ${props => props.theme.colors.lightGray3};
  background-color: ${props => props.theme.colors.white};
  z-index: 100;
  font-family: 'OpenSans';

  & > p {
    color: ${props => props.theme.colors.grayText};
    font-size: ${pxToRem('12px')};
    text-align: right;
    line-height: 1.33;
    margin-bottom: ${pxToRem('10px')};
    cursor: pointer;
  }

  .rdrDateRangeWrapper {
    font-size: ${pxToRem('14px')};
    .nextPrevButtonCustom {
      i {
        display: none;
      }
      color: ${props => props.theme.colors.blue.one};
      background: transparent;
      :hover {
        background: transparent;
      }
      &.rdrPprevButton {
        transform: rotate(-90deg);
      }
      &.rdrNextButton {
        transform: rotate(90deg);
      }
    }
    .rdrMonthAndYearWrapper {
      height: initial;
      padding-top: initial;
    }
    .rdrDayNumber {
      font-weight: 600;
    }
    .rdrDay.rdrDayHovered {
      border: none !important;
    }
    .rdrMonth {
      width: ${pxToRem('300px')};
    }

    .rdrStartEdge,
    .rdrEndEdge {
      background-color: ${props => props.theme.colors.fucsia};
      border-radius: 50%;
      width: ${pxToRem('34px')};
      margin: auto;
      left: 0;
      right: 0;
    }
    .rdrDay:has(> .rdrStartEdge),
    .rdrDay:has(> .rdrEndEdge) {
      background-color: ${props => props.theme.colors.pink.three};
    }
    .rdrInRange {
      background-color: ${props => props.theme.colors.pink.three};
    }
    .rdrDay:not(.rdrDayPassive) .rdrInRange ~ .rdrDayNumber span {
      color: ${props => props.theme.colors.black.one};
    }
    .rdrDayToday .rdrDayNumber span {
      font-weight: 600;
    }
    .rdrDayToday .rdrDayNumber span::after {
      width: ${pxToRem('3px')};
      border-radius: 100%;
      background: ${props => props.theme.colors.black.one};
    }
  }
`;

export const Icon = styled.div`
  ${props =>
    !props.isOpen &&
    css`
      transform: rotate(180deg);
    `};

  color: ${props => props.theme.colors.blue.one};
  font-size: ${pxToRem('20px')};
  transition: all 250ms;
`;

export const LabelWrapper = styled.div`
  position: relative;
`;

export const Title = styled.div`
  ${props =>
    props.datePresent &&
    css`
      transform: scale(0.8) translateX(-${pxToRem('5px')})
        translateY(-${pxToRem('20px')});
      position: absolute;
      transition: all 500ms;
      color: ${props.theme.colors.grayText};
      font-weight: 600;
    `}
`;

export const SplittedDates = styled.div`
  display: flex;
`;

export const Selection = styled.div`
  color: black;
  transition: all 500ms;
  ${props =>
    props.datePresent &&
    css`
      span {
        display: block;
        margin-top: ${pxToRem('14px')};
      }
    `}

  ${props =>
    props.endDateNotSelectedError &&
    css`
      color: ${props.theme.colors.semantic.secondary};
    `}
`;
